module.exports = __webpack_public_path__ + "img/top_slider_202511_vdcampaign.22b80cc6.png";